import { createFileRoute, redirect } from '@tanstack/react-router';

/** 옛 주소 — 공유된 링크·북마크가 깨지지 않게 영구히 리다이렉트만 남긴다 (D146 ③). */
export const Route = createFileRoute('/settings/research-interests')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/account/research-interests', search, replace: true });
  },
});
